import AttachmentsList from '@app/components/AttachmentsList'
import PhotoStrip from '@app/components/PhotoStrip'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { PipelinePageProps } from './PipelinePage'

export default class PipelineFiles extends React.PureComponent<
  PipelinePageProps
> {
  public render() {
    return (
      <DocumentTitle title={`${this.props.pipeline.name} :: Files`}>
        <div className='mb-3'>
          <h5 className='section-title'>Attachments</h5>
          <PhotoStrip
            className='mb-3'
            photos={this.props.pipeline.listing.photos}
          />
          <AttachmentsList
            attachments={this.props.pipeline.listing.property.attachments}
            className='mx-3'
            onChange={this.props.setAttachments}
            key='pipeline-files-list'
            propertyId={this.props.pipeline.listing.property.id}
          />
        </div>
      </DocumentTitle>
    )
  }
}
